<nav class="navbar">
  <div class="title-container">
    <a [routerLink]="['/home']" class="logo-link">
      <img
        src="assets/images/ACM_logo_main.png"
        alt="Angular Community Meetup Logo"
        class="logo"
      />
      <div class="title">
        <h1>Angular Community</h1>
      </div>
    </a>
    <!-- <img src="assets/images/no_banner_small.png" alt="Angular Community Meetup Logo" class="logo">
    <img src="assets/images/words_small.png" alt="Angular Community" class="logo"> -->
  </div>
  <div class="menu-container">
    <button
      mat-button
      aria-label="navigation"
      id="nav-menu"
      [color]="'primary'"
      [matMenuTriggerFor]="menu"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #menu="matMenu" [xPosition]="'before'">
      <a
        mat-menu-item
        class="navlink"
        [routerLink]="['/home']"
        routerLinkActive="active"
        >{{'home' | transloco}}</a
      >
      <!-- <a class="navlink" [routerLink]="['/about']">About Us</a> -->
      <a
        mat-menu-item
        class="navlink"
        [routerLink]="['/events']"
        routerLinkActive="active"
        >{{'events' | transloco}}</a
      >
<!--      <a-->
<!--        mat-menu-item-->
<!--        class="navlink"-->
<!--        [routerLink]="['/podcast']"-->
<!--        routerLinkActive="active"-->
<!--        >{{'podcast' | transloco}}</a-->
<!--      >-->
      <a
        mat-menu-item
        class="navlink"
        [routerLink]="['/sponsors']"
        routerLinkActive="active"
        >{{'sponsors' | transloco}}</a
      >
      <a
        mat-menu-item
        class="navlink"
        [routerLink]="['/code-of-conduct']"
        routerLinkActive="active"
        >{{'codeOfConduct' | transloco}}</a
      >
    </mat-menu>
  </div>
  <div class="links">
    <a
      mat-button
      class="navlink"
      [routerLink]="['/home']"
      routerLinkActive="active"
      >{{'home' | transloco}}</a
    >
    <!-- <a class="navlink" [routerLink]="['/about']">About Us</a> -->
    <a
      mat-button
      class="navlink"
      [routerLink]="['/events']"
      routerLinkActive="active"
      >{{'events'| transloco}}</a
    >
<!--    <a-->
<!--      mat-button-->
<!--      class="navlink"-->
<!--      [routerLink]="['/podcast']"-->
<!--      routerLinkActive="active"-->
<!--      >{{'podcast'| transloco}}</a-->
<!--    >-->
    <a
      mat-button
      class="navlink"
      [routerLink]="['/sponsors']"
      routerLinkActive="active"
      >{{'sponsors' | transloco}}</a
    >
    <a
      mat-button
      class="navlink"
      [routerLink]="['/code-of-conduct']"
      routerLinkActive="active"
      >{{'codeOfConduct' | transloco}}</a
    >
  </div>
</nav>


<main>
  <div class="settings-container">
    <angular-community-language-menu></angular-community-language-menu>
   <angular-community-theme-toggler></angular-community-theme-toggler>
  </div>
  <router-outlet></router-outlet>
</main>
<footer>{{'builtBy' | transloco}}</footer>
